// Conversion constants
const CONVERSIONS = {
    // Energy conversions
    SCM_TO_BOE: 0.0062898,           // 1000 SCM = 6.2898 boe, so 1 SCM = 0.0062898 boe
    SCM_TO_SCF: 35.315,              // 1 SCM = 35.315 scf
    SCM_TO_MJ: 40,                   // 1 SCM = 40 MJ
    SCM_TO_BTU: 37913,               // 1 SCM = 37,913 BTU
    MWH_TO_MJ: 3600,                  // 1 MWh = 3600 MJ
    MMBTU_TO_BTU: 1000000,           // 1 MMBTU = 1,000,000 BTU
};

// Check if is updating
let isUpdating = false;

// Initialize
document.addEventListener('DOMContentLoaded', function() {
    // Check if calculator exists on page
    const calculatorElement = document.querySelector('.price-and-energy-calculator');
    if (calculatorElement) {
        initializeConverter();
        fetchExchangeRates();
    }
});

function initializeConverter() {
    // Add event listeners for price conversion
    const priceFields = ['inputUSDboe', 'inputUSDmmbtu', 'inputEURmwh', 'inputGBPtherm', 'inputEURUSD', 'inputGBPUSD'];
    priceFields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.addEventListener('input', (e) => handlePriceConversion(fieldId, e.target.value));
            field.addEventListener('change', (e) => handlePriceConversion(fieldId, e.target.value));
        }
    });

    // Event listeners for energy conversion
    const energyFields = ['inputBoe', 'inputSM3', 'inputMWh', 'inputSCF', 'inputMMbtu'];
    energyFields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field) {
            field.addEventListener('input', (e) => handleEnergyConversion(fieldId, e.target.value));
            field.addEventListener('change', (e) => handleEnergyConversion(fieldId, e.target.value));
        }
    });
}

async function fetchExchangeRates() {
    const statusDiv = document.getElementById('currency-status');

    try {
        statusDiv.textContent = 'Loading exchange rates...';

        // Norwegian Central Bank API
        const urls = {
            usd: 'https://data.norges-bank.no/api/data/EXR/B.USD.NOK.SP?format=sdmx-json&lastNObservations=1&locale=en',
            eur: 'https://data.norges-bank.no/api/data/EXR/B.EUR.NOK.SP?format=sdmx-json&lastNObservations=1&locale=en',
            gbp: 'https://data.norges-bank.no/api/data/EXR/B.GBP.NOK.SP?format=sdmx-json&lastNObservations=1&locale=en'
        };

        // Fetch all rates
        const [usdResponse, eurResponse, gbpResponse] = await Promise.all([
            fetch(urls.usd),
            fetch(urls.eur),
            fetch(urls.gbp)
        ]);

        const usdData = await usdResponse.json();
        const eurData = await eurResponse.json();
        const gbpData = await gbpResponse.json();

        // Extract rates (NOK per currency)
        const usdNokRate = parseFloat(usdData.data.dataSets[0].series['0:0:0:0'].observations['0'][0]);
        const eurNokRate = parseFloat(eurData.data.dataSets[0].series['0:0:0:0'].observations['0'][0]);
        const gbpNokRate = parseFloat(gbpData.data.dataSets[0].series['0:0:0:0'].observations['0'][0]);

        // Calculate rates
        const eurUsdRate = eurNokRate / usdNokRate;
        const gbpUsdRate = gbpNokRate / usdNokRate;

        // Update the input fields
        document.getElementById('inputEURUSD').value = eurUsdRate.toFixed(4);
        document.getElementById('inputGBPUSD').value = gbpUsdRate.toFixed(4);

        // Update status
        statusDiv.textContent = `Exchange rates updated from Norwegian Central Bank`;
        statusDiv.classList.remove('error');

    } catch (error) {
        console.error('Error fetching exchange rates:', error);
        statusDiv.textContent = 'Failed to load live rates. Using default values.';
        statusDiv.classList.add('error');

        // Keep default values in case of error
        document.getElementById('inputEURUSD').value = '1.1000';
        document.getElementById('inputGBPUSD').value = '1.3000';
    }
}

function handlePriceConversion(sourceField, value) {
    if (isUpdating || !value || isNaN(value)) return;

    isUpdating = true;
    const valPrice = parseFloat(value);

    // Get current exchange rates
    const eurUsd = parseFloat(document.getElementById('inputEURUSD').value) || 1.1;
    const gbpUsd = parseFloat(document.getElementById('inputGBPUSD').value) || 1.3;

    const fields = {
        usdBoe: document.getElementById('inputUSDboe'),
        usdMmbtu: document.getElementById('inputUSDmmbtu'),
        eurMwh: document.getElementById('inputEURmwh'),
        gbpTherm: document.getElementById('inputGBPtherm')
    };

    try {
        switch (sourceField) {
            case 'inputUSDboe':
                // Convert from USD/boe
                fields.usdMmbtu.value = (valPrice / CONVERSIONS.SCM_TO_BOE * CONVERSIONS.SCM_TO_BTU / CONVERSIONS.MMBTU_TO_BTU).toFixed(2);
                fields.eurMwh.value = (valPrice * CONVERSIONS.SCM_TO_BTU / CONVERSIONS.MMBTU_TO_BTU / CONVERSIONS.SCM_TO_BOE * CONVERSIONS.SCM_TO_MJ / CONVERSIONS.MWH_TO_MJ / eurUsd).toFixed(2);
                fields.gbpTherm.value = (valPrice / gbpUsd * CONVERSIONS.SCM_TO_BTU / CONVERSIONS.SCM_TO_BOE / 100000 * 100).toFixed(2);
                break;

            case 'inputEURmwh':
                // Convert from EUR/MWh
                fields.usdBoe.value = (valPrice * eurUsd / CONVERSIONS.SCM_TO_BTU * CONVERSIONS.MMBTU_TO_BTU * CONVERSIONS.MWH_TO_MJ / CONVERSIONS.SCM_TO_MJ * CONVERSIONS.SCM_TO_BOE).toFixed(2);
                fields.usdMmbtu.value = (valPrice * eurUsd * CONVERSIONS.MWH_TO_MJ / CONVERSIONS.SCM_TO_MJ * CONVERSIONS.SCM_TO_BTU / CONVERSIONS.MMBTU_TO_BTU).toFixed(2);
                fields.gbpTherm.value = (valPrice * eurUsd / gbpUsd * CONVERSIONS.MWH_TO_MJ / CONVERSIONS.SCM_TO_MJ * CONVERSIONS.SCM_TO_BTU / 100000 * 100).toFixed(2);
                break;

            case 'inputUSDmmbtu':
                // Convert from USD/MMBTU
                fields.usdBoe.value = (valPrice * CONVERSIONS.MMBTU_TO_BTU / CONVERSIONS.SCM_TO_BTU * CONVERSIONS.SCM_TO_BOE).toFixed(2);
                fields.eurMwh.value = (valPrice / eurUsd * CONVERSIONS.MMBTU_TO_BTU / CONVERSIONS.SCM_TO_BTU * CONVERSIONS.SCM_TO_MJ / CONVERSIONS.MWH_TO_MJ).toFixed(2);
                fields.gbpTherm.value = (valPrice / gbpUsd * 100).toFixed(2); // 1 MMBTU ≈ 10 therms, pence conversion
                break;

            case 'inputGBPtherm':
                // Convert from GBp/therm
                fields.usdMmbtu.value = (valPrice * gbpUsd / 100).toFixed(2); // 100 pence = 1 GBP, ~10 therms = 1 MMBTU
                fields.usdBoe.value = (valPrice * gbpUsd / 100 * CONVERSIONS.MMBTU_TO_BTU / CONVERSIONS.SCM_TO_BTU * CONVERSIONS.SCM_TO_BOE).toFixed(2);
                fields.eurMwh.value = (valPrice * gbpUsd / eurUsd / 100 * CONVERSIONS.MMBTU_TO_BTU / CONVERSIONS.SCM_TO_BTU * CONVERSIONS.SCM_TO_MJ / CONVERSIONS.MWH_TO_MJ).toFixed(2);
                break;

            case 'inputEURUSD':
            case 'inputGBPUSD':
                // Exchange rate changed, trigger conversion from the first non-empty field
                const firstValue = fields.usdBoe.value || fields.usdMmbtu.value || fields.eurMwh.value || fields.gbpTherm.value;
                if (firstValue) {
                    const firstField = fields.usdBoe.value ? 'inputUSDboe' :
                        fields.usdMmbtu.value ? 'inputUSDmmbtu' :
                            fields.eurMwh.value ? 'inputEURmwh' : 'inputGBPtherm';
                    setTimeout(() => handlePriceConversion(firstField, firstValue), 10);
                }
                break;
        }
    } catch (error) {
        console.error('Error in price conversion:', error);
    } finally {
        isUpdating = false;
    }
}

function handleEnergyConversion(sourceField, value) {
    if (isUpdating || !value || isNaN(value)) return;

    isUpdating = true;
    const valNum = parseFloat(value);

    const fields = {
        boe: document.getElementById('inputBoe'),
        sm3: document.getElementById('inputSM3'),
        mwh: document.getElementById('inputMWh'),
        scf: document.getElementById('inputSCF'),
        mmbtu: document.getElementById('inputMMbtu')
    };

    try {
        switch (sourceField) {
            case 'inputBoe':
                fields.sm3.value = (valNum / CONVERSIONS.SCM_TO_BOE).toFixed(2);
                fields.mwh.value = (valNum / CONVERSIONS.SCM_TO_BOE * CONVERSIONS.SCM_TO_MJ / CONVERSIONS.MWH_TO_MJ).toFixed(2);
                fields.scf.value = (valNum / CONVERSIONS.SCM_TO_BOE * CONVERSIONS.SCM_TO_SCF).toFixed(2);
                fields.mmbtu.value = (valNum / CONVERSIONS.SCM_TO_BOE * CONVERSIONS.SCM_TO_BTU / CONVERSIONS.MMBTU_TO_BTU).toFixed(2);
                break;

            case 'inputSM3':
                fields.boe.value = (valNum * CONVERSIONS.SCM_TO_BOE).toFixed(2);
                fields.mwh.value = (valNum * CONVERSIONS.SCM_TO_MJ / CONVERSIONS.MWH_TO_MJ).toFixed(2);
                fields.scf.value = (valNum * CONVERSIONS.SCM_TO_SCF).toFixed(2);
                fields.mmbtu.value = (valNum * CONVERSIONS.SCM_TO_BTU / CONVERSIONS.MMBTU_TO_BTU).toFixed(2);
                break;

            case 'inputMWh':
                fields.boe.value = (valNum * CONVERSIONS.MWH_TO_MJ / CONVERSIONS.SCM_TO_MJ * CONVERSIONS.SCM_TO_BOE).toFixed(2);
                fields.sm3.value = (valNum * CONVERSIONS.MWH_TO_MJ / CONVERSIONS.SCM_TO_MJ).toFixed(2);
                fields.scf.value = (valNum * CONVERSIONS.MWH_TO_MJ / CONVERSIONS.SCM_TO_MJ * CONVERSIONS.SCM_TO_SCF).toFixed(2);
                fields.mmbtu.value = (valNum * CONVERSIONS.MWH_TO_MJ / CONVERSIONS.SCM_TO_MJ * CONVERSIONS.SCM_TO_BTU / CONVERSIONS.MMBTU_TO_BTU).toFixed(2);
                break;

            case 'inputSCF':
                fields.boe.value = (valNum / CONVERSIONS.SCM_TO_SCF * CONVERSIONS.SCM_TO_BOE).toFixed(2);
                fields.sm3.value = (valNum / CONVERSIONS.SCM_TO_SCF).toFixed(2);
                fields.mwh.value = (valNum / CONVERSIONS.SCM_TO_SCF * CONVERSIONS.SCM_TO_MJ / CONVERSIONS.MWH_TO_MJ).toFixed(2);
                fields.mmbtu.value = (valNum / CONVERSIONS.SCM_TO_SCF * CONVERSIONS.SCM_TO_BTU / CONVERSIONS.MMBTU_TO_BTU).toFixed(2);
                break;

            case 'inputMMbtu':
                fields.boe.value = (valNum * CONVERSIONS.MMBTU_TO_BTU / CONVERSIONS.SCM_TO_BTU * CONVERSIONS.SCM_TO_BOE).toFixed(2);
                fields.sm3.value = (valNum * CONVERSIONS.MMBTU_TO_BTU / CONVERSIONS.SCM_TO_BTU).toFixed(2);
                fields.mwh.value = (valNum * CONVERSIONS.MMBTU_TO_BTU / CONVERSIONS.SCM_TO_BTU * CONVERSIONS.SCM_TO_MJ / CONVERSIONS.MWH_TO_MJ).toFixed(2);
                fields.scf.value = (valNum * CONVERSIONS.MMBTU_TO_BTU / CONVERSIONS.SCM_TO_BTU * CONVERSIONS.SCM_TO_SCF).toFixed(2);
                break;
        }
    } catch (error) {
        console.error('Error in energy conversion:', error);
    } finally {
        isUpdating = false;
    }
}